import { Component } from '@angular/core';
import { ReactiveFormsModule } from '@angular/forms';
import { InputOtpModule } from 'primeng/inputotp';
import { FormFieldComponent } from '@shared/models/classes/FormFieldComponent';

@Component({
  standalone: true,
  selector: 'pm-form-field-input-otp',
  imports: [InputOtpModule, ReactiveFormsModule],
  templateUrl: './pm-form-field-input-otp.component.html',
  styleUrl: './pm-form-field-input-otp.component.scss',
})
export class PmFormFieldInputOtpComponent extends FormFieldComponent {}
